/**
 * @generated SignedSource<<0ce2e2e6e65d242dfe21c574804423b2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type presetConfigurationsQueriesDeleteCategoryMutation$variables = {
  id: number;
  macroId: number;
};
export type presetConfigurationsQueriesDeleteCategoryMutation$data = {
  readonly deleteCompositionCategory: {
    readonly categoryID: number;
    readonly displayOrder: number;
    readonly id: string;
    readonly name: string | null;
  };
};
export type presetConfigurationsQueriesDeleteCategoryMutation = {
  response: presetConfigurationsQueriesDeleteCategoryMutation$data;
  variables: presetConfigurationsQueriesDeleteCategoryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "macroId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "macroId",
        "variableName": "macroId"
      }
    ],
    "concreteType": "CompositionCategory",
    "kind": "LinkedField",
    "name": "deleteCompositionCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "categoryID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayOrder",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "presetConfigurationsQueriesDeleteCategoryMutation",
    "selections": (v2/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "presetConfigurationsQueriesDeleteCategoryMutation",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "76595cece3c12065a0808b02e57ebe28",
    "id": null,
    "metadata": {},
    "name": "presetConfigurationsQueriesDeleteCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation presetConfigurationsQueriesDeleteCategoryMutation(\n  $macroId: Long!\n  $id: Long!\n) {\n  deleteCompositionCategory(macroId: $macroId, id: $id) {\n    id\n    categoryID\n    name\n    displayOrder\n  }\n}\n"
  }
};
})();

(node as any).hash = "ba620ff06e5fe9d8fee33cd9db61dc56";

export default node;
